import React from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import { CartProvider } from '../contexts/CartContext';
import { LoginProvider } from '../contexts/LoginContext';
import { CouponProvider } from '../contexts/CouponContext';
import { ToastProvider } from '../contexts/ToastContext';

// Wrapper component to ensure proper provider order
export const AppProviders = ({ children }) => {
  try {
    return (
      <AuthProvider>
        <LoginProvider>
          <ToastProvider>
          <CartProvider>
            <CouponProvider>
              {children}
            </CouponProvider>
          </CartProvider>
          </ToastProvider>
        </LoginProvider>
      </AuthProvider>
    );
  } catch (error) {
    console.error('Error in AppProviders:', error);
    // Fallback: render children without providers if there's an error
    return <>{children}</>;
  }
};
